module.exports = __webpack_public_path__ + "img/add-recipe.dd2c483b.gif";